import { FlowRouterContext } from 'nove8/contexts/flowRouterContext'
import { useContext, useEffect } from 'react'

export const usePageRequiredAction = (): void => {
  const { onPageLoad } = useContext(FlowRouterContext)

  useEffect(() => {
    onPageLoad()
  }, [onPageLoad])
}
